import { addressSteps } from "@/mocks/homeData";

export default function LatestAddressSection() {
  return (
    <section id="address" className="w-full bg-background-100 py-16 md:py-24">
      <div className="w-full px-4 md:px-8 max-w-6xl mx-auto">
        <div className="grid grid-cols-1 lg:grid-cols-12 gap-10 lg:gap-14">
          <div className="lg:col-span-5">
            <span className="inline-flex items-center gap-2 text-primary-600 text-sm font-medium">
              <i className="ri-links-line" />
              最新地址
            </span>
            <h2 className="mt-3 font-heading text-foreground-950 text-2xl md:text-4xl">
              旧链接失效时，用四步找到可用地址
            </h2>
            <p className="mt-4 text-foreground-600 text-sm md:text-base leading-relaxed">
              由于网络环境会不断变化，地址偶尔需要更新，这属于正常情况。与其凭记忆反复尝试，不如按下面的步骤重新确认。
            </p>

            <div className="mt-8 rounded-lg bg-primary-500 p-5 md:p-6 text-background-50">
              <div className="flex items-center gap-2 text-sm font-medium">
                <i className="ri-information-line" />
                重要提醒
              </div>
              <p className="mt-3 text-sm leading-relaxed text-background-50/90">
                最新地址请一律以官方发布的渠道为准。任何来源不明的跳转页、群消息或第三方站点都可能有风险，不要在上面输入账号信息或下载程序。
              </p>
            </div>

            <div className="mt-5 rounded-lg bg-background-50 border border-background-200/70 p-5">
              <div className="flex items-center gap-2 text-secondary-700 text-sm font-medium">
                <i className="ri-bookmark-3-line" />
                小技巧：多留几个备份
              </div>
              <p className="mt-3 text-foreground-600 text-sm leading-relaxed">
                把入口同时保存在浏览器书签、手机备忘录和常用笔记里。某处失效时，可以立刻从另一处切换，不必重新发愁找不到。
              </p>
            </div>
          </div>

          <div className="lg:col-span-7">
            <ol className="space-y-4">
              {addressSteps.map((item) => (
                <li
                  key={item.step}
                  className="flex gap-4 md:gap-5 rounded-lg bg-background-50 border border-background-200/70 p-5 md:p-6"
                >
                  <span className="shrink-0 w-11 h-11 md:w-12 md:h-12 flex items-center justify-center rounded-full bg-accent-100 text-accent-900 font-heading text-lg">
                    {item.step}
                  </span>
                  <div>
                    <h3 className="font-heading text-foreground-950 text-lg">{item.title}</h3>
                    <p className="mt-2 text-foreground-600 text-sm leading-relaxed">{item.desc}</p>
                  </div>
                </li>
              ))}
            </ol>
          </div>
        </div>
      </div>
    </section>
  );
}